import { useState } from 'react';
import { history, History } from 'umi';
import {
  getOriginalShortLinkFilter,
  URL_FILTER_KEY,
  ShortLinkQueryType,
  ShortLinkPageValidCfgType,
} from '@intelligence/utils/urlPathCfg';

interface IShortLinkProps {
  hasUrlShortLink: boolean;
  getPageValidCfg: (urlFilter?: any) => ShortLinkPageValidCfgType;
  getCustomValidUrlParams: (
    history: History,
    validCfg: ShortLinkPageValidCfgType,
  ) => { params: object; validQuery: object; };
  urlFilterValue?: any;
}

export function useShortLink(props: IShortLinkProps) {
  const { hasUrlShortLink, getPageValidCfg, getCustomValidUrlParams, urlFilterValue } = props || {};

  // 获取短链接queryToken对应的筛选器返回值接口-loading状态
  const [shortLinkLoading, setShortLinkLoading] = useState<boolean>(hasUrlShortLink);
  // 从短链接中拿到校正后的url参数
  const [urlCustomParams, setUrlCustomParams] = useState<{ [key: string]: any }>({});
  // 筛选器有效的页面配置值
  const [shortLinkValidQuery, setShortLinkValidQuery] = useState<ShortLinkQueryType>({
  });
  const [shortLinkFilterValue, setShortLinkFilterValue] = useState(null);

  const initShortLinkCfg = async () => {
    setShortLinkLoading(true);
    // 在url上取token，有则请求接口， 判断异常，返回函数值和url上的其他配置参数
    const { [URL_FILTER_KEY]: urlFilter } = await getOriginalShortLinkFilter();
    // 有筛选器的token时后面的页面配置才有效，没有token时后面的url页面配置无效
    if (urlFilter) {
      const pageValidCfg = getPageValidCfg?.(urlFilter);
      const { params, validQuery } = getCustomValidUrlParams?.(history, pageValidCfg);
      setUrlCustomParams({ ...params });
      setShortLinkValidQuery({ ...shortLinkValidQuery, ...validQuery });
      setShortLinkFilterValue(urlFilter);
    }
    setShortLinkLoading(false);
  };

  const initShortLinkCfgNoAwait = async () => {
    // 不请求短链接接口，如果外面有请求了筛选器，可以传过来赋值
    if (urlFilterValue) {
      setShortLinkLoading(true);
      await setShortLinkFilterValue(urlFilterValue);
      setShortLinkLoading(false);
    }else{
      setShortLinkLoading(false);
    }
    // 有筛选器的token时后面的页面配置才有效，没有token时后面的url页面配置无效
    const pageValidCfg = getPageValidCfg?.({});
    const { params, validQuery } = getCustomValidUrlParams?.(history, pageValidCfg);
    setUrlCustomParams({ ...params });
    setShortLinkValidQuery({ ...shortLinkValidQuery, ...validQuery });
  };

  return {
    initShortLinkCfg,
    initShortLinkCfgNoAwait,
    shortLinkLoading,
    urlCustomParams,
    shortLinkFilterValue,
    shortLinkValidQuery,
  };
}